import Login from '@/views/login'
import Home from '@/views/layout/home'
import membersList from '@/views/members/membersList'
import membersRecord from '@/views/members/membersRecord'
import projectList from '@/views/project/projectList'
import projectDes from '@/views/project/projectDes'
import mutualHelpList from '@/views/mutualHelp/mutualHelpList'
import manager from '@/views/manager/manager'
import dealFlow from '@/views/remuneration/dealFlow'
import settlement from '@/views/remuneration/settlement'
import summary from '@/views/remuneration/summary'
import projectTransaction from '@/views/remuneration/projectTransaction'
import payRecords from '@/views/remuneration/payRecords'
import agent from '@/views/agent'
import myAgentCode from '@/views/agent/myCode'
import agentList from '@/views/agent/list'
import subordinate from '@/views/agent/subordinate'
import questionnaireList from '@/views/agent/questionnaireList'
import tagMgt from '@/views/tagMgt'
import enterprise from '@/views/enterprise'
import enterpriseDetail from '@/views/enterprise/detail'
import partnerDetail from '@/views/enterprise/partnerDetail'
import devCommissioner from '@/views/agent/devCommissioner'
import devCommissionerDetail from '@/views/agent/devCommissioner/detail'
import role from '@/views/role'

const routes = [
 {
  path: '/login',
  name: '登录',
  component: Login,
 },
 {
  path: '/',
  redirect: '/membersList',
  name: 'home',
  component: Home,
  children: [
   {
    path: '/membersList',
    name: 'membersList',
    component: membersList,
   },
   {
    path: '/membersRecord',
    name: 'membersRecord',
    component: membersRecord,
   },
   {
    path: '/projectList',
    name: 'projectList',
    component: projectList,
   },
   {
    path: '/projectDes',
    name: 'projectDes',
    component: projectDes,
   },
   {
    path: '/mutualHelpList',
    name: 'mutualHelpList',
    component: mutualHelpList,
   },
   {
    path: '/manager',
    name: 'manager',
    component: manager,
   },
   {
    path: '/role',
    name: 'Role',
    component: role,
   },
   {
    path: '/remuneration/dealFlow',
    name: 'dealFlow',
    component: dealFlow,
   },
   {
    path: '/remuneration/settlement',
    name: 'settlement',
    component: settlement,
   },
   {
    path: '/remuneration/summary',
    name: 'summary',
    component: summary,
   },
   {
    path: '/remuneration/projectTransaction',
    name: 'projectTransaction',
    component: projectTransaction,
   },
   {
    path: '/remuneration/payRecords',
    name: 'payRecords',
    component: payRecords,
   },
   {
    path: '/agent',
    name: 'agent',
    component: agent,
    redirect: '/agent/code',
    children: [
     {
      path: '/agent/myCode',
      name: 'myAgentCode',
      component: myAgentCode,
     },
     {
      path: '/agent/list',
      name: 'agentList',
      component: agentList,
     },
     {
      path: '/subordinate/list',
      name: 'subordinate',
      component: subordinate,
     },
     {
      path: '/agent/questionnaireList',
      name: 'questionnaireList',
      component: questionnaireList,
     },
     {
      path: '/agent/devCommissioner',
      name: 'DevCommissioner',
      component: devCommissioner,
     },
     {
      path: '/agent/devCommissionerDetail',
      name: 'DevCommissionerDetail',
      component: devCommissionerDetail,
     },
    ]
   },
   {
    path: '/tagMgt',
    name: 'tagMgt',
    component: tagMgt,
   },
   {
    path: '/enterprise',
    name: 'enterprise',
    component: enterprise,
   },
   {
    path: '/enterpriseDetail',
    name: 'EnterpriseDetail',
    component: enterpriseDetail,
   },
   {
    path: '/partnerDetail',
    name: 'PartnerDetail',
    component: partnerDetail,
   },
  ],
 },
]

export default routes
